// Import all individual exercise files
const miniSquats = require('./exercises/mini_squats.js');
const bigArmSwings = require('./exercises/big_arm_swings.js');
const fastFeet = require('./exercises/fast_feet.js');
const oneLegStand = require('./exercises/one_leg_stand.js');
const starJumps = require('./exercises/star_jumps.js');
const highKnees = require('./exercises/high_knees.js');
const armCircles = require('./exercises/arm_circles.js');
const sideLunges = require('./exercises/side_lunges.js');
const jumpingJacks = require('./exercises/jumping_jacks.js');
const frogJumps = require('./exercises/frog_jumps.js');
const plank = require('./exercises/plank.js');
const skaterHops = require('./exercises/skater_hops.js');
const burpees = require('./exercises/burpees.js');
const mountainClimbers = require('./exercises/mountain_climbers.js');
const bearCrawl = require('./exercises/bear_crawl.js');
const crabWalk = require('./exercises/crab_walk.js');
const rabbitHops = require('./exercises/rabbit_hops.js');
const tigerPounces = require('./exercises/tiger_pounces.js');
const zebraGallops = require('./exercises/zebra_gallops.js');

const rainbowReaches = require('./exercises/rainbow_reaches.js');
const pushUps = require('./exercises/push_ups.js');
const upperCuts = require('./exercises/upper_cuts.js');
const shoulderTaps = require('./exercises/shoulder_taps.js');
const tricepDips = require('./exercises/tricep_dips.js');
const inchwormWalk = require('./exercises/inchworm_walk.js');
const bridgeHolds = require('./exercises/bridge_holds.js');
const wallSits = require('./exercises/wall_sits.js');
const supermanHolds = require('./exercises/superman_holds.js');

// Import advanced exercises
const mountainClimberBurpees = require('./exercises/mountain_climber_burpees.js');
const jumpSquats = require('./exercises/jump_squats.js');
const tuckJumps = require('./exercises/tuck_jumps.js');
const splitJumps = require('./exercises/split_jumps.js');
const stepJumps = require('./exercises/step_jumps.js');
const sprintIntervals = require('./exercises/sprint_intervals.js');
const diamondPushUps = require('./exercises/diamond_push_ups.js');
const pikePushUps = require('./exercises/pike_push_ups.js');
const singleLegSquats = require('./exercises/single_leg_squats.js');
const lSitHold = require('./exercises/l_sit_hold.js');
const dragonWalk = require('./exercises/dragon_walk.js');
const singleLegDeadlifts = require('./exercises/single_leg_deadlifts.js');
const thrusters = require('./exercises/thrusters.js');

// Combine all exercises into a single array
const allExercises = [
  miniSquats,
  bigArmSwings,
  fastFeet,
  oneLegStand,
  starJumps,
  highKnees,
  armCircles,
  sideLunges,
  jumpingJacks,
  frogJumps,
  plank,
  skaterHops,
  burpees,
  mountainClimbers,
  bearCrawl,
  crabWalk,
  rabbitHops,
  tigerPounces,
  zebraGallops,
  rainbowReaches,
  pushUps,
  upperCuts,
  shoulderTaps,
  tricepDips,
  inchwormWalk,
  bridgeHolds,
  wallSits,
  supermanHolds,
  // Advanced exercises
  mountainClimberBurpees,
  jumpSquats,
  tuckJumps,
  splitJumps,
  stepJumps,
  sprintIntervals,
  diamondPushUps,
  pikePushUps,
  singleLegSquats,
  lSitHold,
  dragonWalk,
  singleLegDeadlifts,
  thrusters,
];

// Helper functions for filtering exercises
const getExercisesByCategory = (category) => {
  return allExercises.filter((ex) => ex.categories.includes(category));
};

const getExercisesBySport = (sport) => {
  return allExercises.filter((ex) => ex.sports.includes(sport));
};

const getExercisesByDifficulty = (difficulty) => {
  return allExercises.filter((ex) => ex.difficulty === difficulty);
};

const getExercisesBySkill = (skill) => {
  return allExercises.filter((ex) => ex.skill === skill);
};

const getExercisesByPoints = (minPoints, maxPoints) => {
  return allExercises.filter(
    (ex) => ex.points >= minPoints && ex.points <= maxPoints
  );
};

const getExercisesByDuration = (minDuration, maxDuration) => {
  return allExercises.filter((ex) => {
    const duration = ex.timedInstructions
      ? ex.timedInstructions[ex.timedInstructions.length - 1].time
      : 0;
    return duration >= minDuration && duration <= maxDuration;
  });
};

const getExercisesByFilters = (filters = {}) => {
  let filtered = [...allExercises];

  if (filters.category) {
    filtered = filtered.filter((ex) =>
      ex.categories.includes(filters.category)
    );
  }

  if (filters.sport) {
    filtered = filtered.filter((ex) => ex.sports.includes(filters.sport));
  }

  if (filters.difficulty) {
    filtered = filtered.filter((ex) => ex.difficulty === filters.difficulty);
  }

  if (filters.skill) {
    filtered = filtered.filter((ex) => ex.skill === filters.skill);
  }

  return filtered;
};

// Get all available categories
const getAllCategories = () => {
  const categories = new Set();
  allExercises.forEach((ex) => {
    ex.categories.forEach((cat) => categories.add(cat));
  });
  return Array.from(categories).sort();
};

// Get all available sports
const getAllSports = () => {
  const sports = new Set();
  allExercises.forEach((ex) => {
    ex.sports.forEach((sport) => sports.add(sport));
  });
  return Array.from(sports).sort();
};

// Get all available difficulties
const getAllDifficulties = () => {
  const difficulties = new Set();
  allExercises.forEach((ex) => difficulties.add(ex.difficulty));
  return Array.from(difficulties).sort();
};

// Get all available skills
const getAllSkills = () => {
  const skills = new Set();
  allExercises.forEach((ex) => skills.add(ex.skill));
  return Array.from(skills).sort();
};

// Export everything using CommonJS
module.exports = {
  allExercises,
  getExercisesByCategory,
  getExercisesBySport,
  getExercisesByDifficulty,
  getExercisesBySkill,
  getExercisesByPoints,
  getExercisesByDuration,
  getExercisesByFilters,
  getAllCategories,
  getAllSports,
  getAllDifficulties,
  getAllSkills,
  // Individual exercises for direct access
  miniSquats,
  bigArmSwings,
  fastFeet,
  oneLegStand,
  starJumps,
  highKnees,
  armCircles,
  sideLunges,
  jumpingJacks,
  frogJumps,
  plank,
  skaterHops,
  burpees,
  mountainClimbers,
  bearCrawl,
  crabWalk,
  rabbitHops,
  tigerPounces,
  zebraGallops,
  rainbowReaches,
  pushUps,
  upperCuts,
  shoulderTaps,
  tricepDips,
  inchwormWalk,
  bridgeHolds,
  wallSits,
  supermanHolds,
  // Advanced exercises
  mountainClimberBurpees,
  jumpSquats,
  tuckJumps,
  splitJumps,
  stepJumps,
  sprintIntervals,
  diamondPushUps,
  pikePushUps,
  singleLegSquats,
  lSitHold,
  dragonWalk,
  singleLegDeadlifts,
  thrusters,
};
